<template>
	<div class="loading">
		<Icon
			name="loading"
			filled
		/>
	</div>
</template>

<style lang="scss" scoped>
.loading {
	@apply h-[24px] w-[24px];
	:deep(.icon) {
		transform-origin: center;
		animation: loading 1.2s linear infinite;
	}
}

@keyframes loading {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
